import {isThenable} from "./internal/is";
import nameFn from "./internal/namefn";

export default nameFn("isPromise", isThenable);
